module.exports = __webpack_public_path__ + "static/media/bathroomSink180.4c359bbc.png";